import React, { useState } from "react";
import ProductLists from "../../components/shopping/ProductLists";
import { ApiHook } from "../../hooks/apiHook";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setShoppingTab } from "../../store/reducers/shoppingReducer";

const ShoppingLayout = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const nav = useNavigate();
  const params = useParams();
  
  const [activeTabBtn, setActiveTabBtn] = useState(params.activeTab || "repurchase");
    const [searchInputs, setSearchInputs] = useState({
      username: "",
      fullname: "",
      address: "",
      forUserId: "",
    });
  
  const items = ApiHook.CallRepurchaseItems(activeTabBtn);

  const changeTab = (tab) => {
    nav(`/shopping/${tab}`)
    setActiveTabBtn(tab)
    dispatch(setShoppingTab(tab))
    setSearchInputs({
      username: "",
      fullname: "",
      address: "1",
      forUserId: "",
    })
  }
  
  return (
    <>
      <div className="page_head_top">{t("shopping")}</div>
      <div className="ewallet_top_btn_sec">
        <div className="row justify-content-between">
          <div className="col-md-4 text-end">
            <div className="dropdown btn-group top_right_pop_btn_position">
              <Link to={"/repurchase-report"} className="top_righ_pop_btn">
                Purchase Report
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: "80px", gap: "5px", marginBottom: "10px", width: "100%" }}>
        <div className={`ewallet_top_btn_sec_tab ${activeTabBtn === "repurchase" ? "active" : ""}`} onClick={() => changeTab("repurchase")}>Fast Track</div>
        <div className={`ewallet_top_btn_sec_tab ${activeTabBtn === "rbvPack" ? "active" : ""}`} onClick={() => changeTab("rbvPack")}>Repurchase</div>
      </div>
      <ProductLists products={items?.data} isLoading={items.isLoading} activeTab={activeTabBtn} searchInputs={searchInputs} setSearchInputs={setSearchInputs}/>
    </>
  );
};

export default ShoppingLayout;
